import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { GetBlobStorageDocumentInput, BlobStorageFileVersionListQuery, PagingResultModelOfBlobStorageModel } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_BLOB_STORAGE_FILE_VERSIONS = gql`
    query blobStorageFileVersionList($input: GetBlobStorageDocumentInput!) {
        blobStorageFileVersions (input: $input) {
            cursor {
                nextPage
                previousPage
              }
            totalCount
            nodes {
                id
                blobDocumentType
                blobFileName
                comment
                fileName
                isActive
                version
                createdBy
                createdByName
                createdTime
                lastModifiedBy
                lastModifiedByName
                lastModifiedTime
                
                blobStorageReference {
                    id
                    blobStorageId
                    blobDocumentId
                }
                
            }
        }
    }
`;

export const queryBlobStorageFileVersionList = async (
    client: ApolloClient<NormalizedCacheObject>,
    filters?: GetBlobStorageDocumentInput
): Promise<PagingResultModelOfBlobStorageModel | undefined> => {
    const { after, limit, order, id, blobDocumentId, blobDocumentType, blobStorageFileName, blobStorageDateFrom, blobStorageDateTo } = filters ?? {};
    const { data, errors } = await client.query<BlobStorageFileVersionListQuery>({
        variables: {
            input: {
                after,
                limit,
                id,
                blobDocumentId,
                blobDocumentType,
                blobStorageFileName, 
                blobStorageDateFrom, 
                blobStorageDateTo,
                order
            }
        },
        query: QUERY_BLOB_STORAGE_FILE_VERSIONS,
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    return data?.blobStorageFileVersions as PagingResultModelOfBlobStorageModel;
}